import axios from "axios";
import {ELASTIC_SEARCH_CAMPAIGNS_INDEX} from "../../firebase";
import {updateData} from "../../firebaseCRUD";
import moment from "moment";

export const getFeaturedCampaigns = async () => {
    const body = {
        query: {
            function_score: {
                query: {
                    bool: {
                        filter: {
                            bool: {
                                should: [
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    term: {
                                                        featured: true,
                                                    }
                                                }
                                            ]
                                        },
                                    },
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    term: {
                                                        featured: true,
                                                    },
                                                },
                                                {
                                                    range: {
                                                        "featuredExpirationDate._seconds": {
                                                            lte: moment.utc().add(5, 'days').valueOf() / 1000,
                                                            gte: moment.utc().valueOf() / 1000
                                                        }
                                                    }
                                                }
                                            ]
                                        },
                                    }
                                ],
                                must_not: {
                                    exists: {
                                        field: 'hidden'
                                    },
                                }
                            }
                        }
                    },
                },
                boost_mode: "replace",
                functions: [
                    {
                        random_score:  {
                            seed: parseInt(Math.random() * 100)
                        }
                    }
                ],
            },
        },
        size: 50
    }
    return axios
        .post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, body)
}

export const toggleFeatured = (campaignId, isFeatured) => {
    return updateData({
        id: campaignId,
        data: {'featured': isFeatured},
        collection: 'campaigns'
    })
}